import type {
  LocalCompactionConfig,
  LocalCompactionOption,
  ResolvedLocalCompactionConfig,
} from './types';

export function isLocalCompactionEnabled(
  runOption?: LocalCompactionOption,
  runnerOption?: LocalCompactionOption,
): boolean {
  return resolveLocalCompactionConfig(runOption, runnerOption).enabled;
}

export function resolveLocalCompactionConfig(
  runOption?: LocalCompactionOption,
  runnerOption?: LocalCompactionOption,
): ResolvedLocalCompactionConfig {
  const runnerConfig = normalizeOption(runnerOption);
  const runConfig = normalizeOption(runOption);
  if (runOption === false) {
    return withDefaults({ enabled: false });
  }
  return withDefaults({
    ...runnerConfig,
    ...runConfig,
    enabled: runConfig.enabled ?? runnerConfig.enabled ?? false,
  });
}

function normalizeOption(
  option?: LocalCompactionOption,
): LocalCompactionConfig {
  if (option === true) {
    return { enabled: true };
  }
  if (option === false || typeof option === 'undefined') {
    return {};
  }
  return option;
}

function withDefaults(
  config: LocalCompactionConfig,
): ResolvedLocalCompactionConfig {
  return {
    ...config,
    enabled: config.enabled ?? false,
    auto: config.auto ?? true,
    thresholdRatio: config.thresholdRatio ?? 0.85,
    reserveOutputTokens: config.reserveOutputTokens ?? 20_000,
    preservedTailTokens: config.preservedTailTokens ?? 12_000,
    preservedTailMessages: config.preservedTailMessages ?? 8,
    minTextMessagesToKeep: config.minTextMessagesToKeep ?? 4,
    maxSummaryTokens: config.maxSummaryTokens ?? 20_000,
    failureFuseThreshold: 3,
  };
}
